import { styled } from "@mui/material/styles";
import { MenuItem } from "@mui/material";

export const MenuItemStyled = styled(MenuItem)(
  ({ theme }) => `
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 500;
    color: var(--on-surface-secondary);
    text-decoration: none;
    padding: 12px 0;
    cursor: pointer;
    & .MuiListItemIcon-root {
      min-width: auto;
    }
    & .MuiListItemText-root {
      margin: 0;
    }
    &.active {
      color: var(--on-surface-primary);
    }
    & .MuiListItemIcon-root, & .MuiSvgIcon-root {
      color: inherit;
    }
    :hover {
      background-color: transparent;
      color: ${theme.palette.primary.main};
      & .MuiListItemIcon-root {
        color: ${theme.palette.primary.main};
      }
    }
    & .MuiButtonGroup-root {
      & .MuiButton-root {
        color: var(--on-surface-secondary);
        &:first-child {
          padding-left: 0;
          & .MuiButton-startIcon {
            margin: 0 12px 0 0;
          }
        }
        &:hover {
          color: ${theme.palette.primary.main};
          & .MuiListItemIcon-root {
            color: ${theme.palette.primary.main};
          }
        }
      }
    }`
);
